import axios from 'axios'
import crypto from '@/helpers/crypto'
import states from '@/helpers/states'

export function axiosHandler() {
    axios.defaults.baseURL = states.getBackEndUrlByState()
    let access = localStorage.getItem('access');
    if(access) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + crypto.decrypt(access);
    }

    axios.interceptors.response.use(
        res => {
            if (res.data.status && (res.data.status === 'Token is Expired' || res.data.status === 'Token is Invalid')) {
                localStorage.removeItem('access')
                localStorage.removeItem('ttl')
                return window.location.href = '/login'
            } else {
                return res
            }
        },
        error => {
            return Promise.reject(error);
        }
    )
}